import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AwsIntegrationIntentProjectAttachment,
  MutationAwsIntegrationIntentProjectDetachArgs,
} from "types/generated";

import { AWS_INTEGRATION_ATTACHMENT_FRAGMENT } from "../gql";

export const DETACH_AWS_INTEGRATION_FROM_INTENT_PROJECT: TypedDocumentNode<
  { awsIntegrationIntentProjectDetach: AwsIntegrationIntentProjectAttachment },
  MutationAwsIntegrationIntentProjectDetachArgs
> = gql`
  mutation DetachAwsIntegrationFromIntentProject($intentProject: ID!, $integration: ID!) {
    awsIntegrationIntentProjectDetach(intentProject: $intentProject, integration: $integration) {
      ...AwsIntegrationAttachment
    }
  }
  ${AWS_INTEGRATION_ATTACHMENT_FRAGMENT}
`;
